<template>
  <div class="login">
    <van-nav-bar title="安享花登录" :safe-area-inset-top="true" :border="false" left-arrow @click-left="$router.replace('/home')" />
    <div class="hero-mini">
      <img src="../assets/img/penguin.png" alt="" />
      <div class="txt">
        <div class="t1">安享花 欢迎您</div>
        <div class="t2">超快下款 超低利率</div>
      </div>
    </div>

    <van-form @submit="onSubmit">
      <div class="form">
        <van-field
          v-model="phone"
          name="phone"
          type="tel"
          maxlength="11"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '请填写手机号' }, { validator: validatePhone, message: '请输入正确的手机号' }]"
        />
        <van-field
          v-model="captchaCode"
          center
          name="captchaCode"
          maxlength="8"
          placeholder="请输入图形验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        >
          <template #button>
            <div class="captcha-box" @click="loadCaptcha">
              <img v-if="captchaImage" :src="captchaImage" alt="验证码" />
              <span v-else class="captcha-tip">{{ captchaLoading ? '加载中' : '点击刷新' }}</span>
            </div>
          </template>
        </van-field>
        <van-button
          round
          block
          native-type="submit"
          color="linear-gradient(to right,#6aa8f5, #3d8aef)"
          :loading="loading"
        >立即登录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { captchaLogin, fetchCaptcha } from '@/api/request.js'

const PHONE_REG = /^1[3-9]\d{9}$/

export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      captchaId: '',
      captchaCode: '',
      captchaImage: '',
      captchaLoading: false,
      loading: false
    }
  },
  created() {
    this.loadCaptcha()
  },
  methods: {
    validatePhone(val) {
      return PHONE_REG.test(val)
    },
    async loadCaptcha() {
      this.captchaLoading = true
      try {
        const res = await fetchCaptcha()
        const data = res.data || {}
        this.captchaId = data.captchaId || ''
        this.captchaImage = data.image || ''
        this.captchaCode = ''
      } catch (e) {
        this.captchaId = ''
        this.captchaImage = ''
      } finally {
        this.captchaLoading = false
      }
    },
    async onSubmit() {
      if (!this.phone || !PHONE_REG.test(this.phone)) {
        this.$toast('请输入正确的手机号')
        return
      }
      if (!String(this.captchaCode || '').trim()) {
        this.$toast('请输入验证码')
        return
      }
      this.loading = true
      try {
        const res = await captchaLogin({
          phone: this.phone,
          captchaId: this.captchaId,
          captchaCode: this.captchaCode
        })
        const data = res.data
        localStorage.setItem('token', data.token)
        localStorage.setItem('phone', data.user.phone)
        localStorage.setItem('user_info', JSON.stringify(data.user))
        this.$toast.success('欢迎登录')
        const redirect = (this.$route.query && this.$route.query.redirect) || '/home'
        this.$router.replace(String(redirect).startsWith('/') ? redirect : '/home')
      } catch (e) {
        // 验证失败后刷新图形码
        this.loadCaptcha()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  min-height: 100%;
  background: linear-gradient(180deg, #6aa8f5 0%, #4b96f0 28%, #f3f6fb 28%);
}
.van-nav-bar {
  background: transparent;
  /deep/ .van-nav-bar__title,
  /deep/ .van-icon {
    color: #fff;
  }
}
.hero-mini {
  display: flex;
  align-items: center;
  color: #fff;
  padding: 10px 24px 28px;
  img {
    width: 72px;
    height: 72px;
    object-fit: contain;
    margin-right: 12px;
  }
  .t1 { font-size: 20px; font-weight: 700; }
  .t2 { margin-top: 6px; font-size: 12px; opacity: .9; }
}
.form {
  margin: 0 16px;
  background: #fff;
  border-radius: 16px;
  padding: 18px 16px 24px;
  box-shadow: 0 8px 24px rgba(31,45,61,.06);
  .van-button {
    margin-top: 18px;
  }
  /deep/ .van-field__button {
    padding-left: 8px;
  }
}
.captcha-box {
  width: 110px;
  height: 36px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .captcha-tip {
    font-size: 12px;
    color: #969799;
  }
}
</style>
